<!-- Confirmation Component -->
<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData">
    <ds-confirmation-link-area>
      <button ds-button class="-outline margin-right-10" (click)="routeToPolicies()">
        View Your Policy
      </button>
      <button ds-button class="-outline-white" (click)="routeToRiskSelection()">
        Change Another Policy
      </button>
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>
